import { LitElement, css, html } from 'lit'

/*  Обычный слайдер для ручной прокрутки c залипанием */ 

export class DzScroll extends LitElement {

    static get properties() {
        return {
          itemsMinCount: { type: Number },
        }
    }

    updated() {
        let slot = this.shadowRoot.getElementById("main-slot")
        let first_item = slot.assignedElements({flatten: true})[0]
        let item_style = window.getComputedStyle(first_item)       
        this.stepSize = 
            first_item.getBoundingClientRect().width +
            parseInt(item_style.marginLeft, 10) + 
            parseInt(item_style.marginRight, 10)
    }


    getBaseElements() {
        return {
            container: this.renderRoot.getElementById("container"),
            slot: this.renderRoot.getElementById("main-slot")
        }
    }


    constructor() {
        super()
        this.wasMoved = false
        this.itemsMinCount = 1
        this.capturedTarget = null
        
 
        this.addEventListener("pointerdown", (evt) => {
            let base = this.getBaseElements() 
            let num_slots = base.slot.assignedElements({flatten: true}).length
            
            base.container.style.transition = "none"
            
            this.onpointermove = (evt) => {
                let left_dx = parseInt(window.getComputedStyle(base.container).left, 10) + evt.movementX
                let clip_left = Math.max(1, num_slots - this.itemsMinCount) * -this.stepSize
                
                left_dx = Math.max(clip_left, Math.min(0, left_dx))
                base.container.style.left = `${left_dx}px`
                this.wasMoved = true
            }
            this.capturedTarget = evt.target
            this.setPointerCapture(evt.pointerId)
        })

        this.addEventListener("pointerup", (evt) => {
            let base = this.getBaseElements()
            let offset = parseInt(window.getComputedStyle(base.container).left, 10)
            
            offset = Math.round(offset / this.stepSize) * this.stepSize
            base.container.style.transition = `0.2s`
            base.container.style.left = `${offset}px`
            
            this.onpointermove = null
            this.releasePointerCapture(evt.pointerId)

            if (!this.wasMoved) {
                this.capturedTarget.click()
            }
            this.wasMoved = false
        })
    }

    render() {
        return html`<div id="container"><slot id="main-slot"></slot></div>`
    }

    static get styles() {
        return css`
            :host {
                display: block;
                box-sizing: border-box;
                overflow: hidden;
                position: relative;
                transition: 0.5s;
                touch-action: none;
            }

            #container {
                position: relative;
                left: 0;
                display: flex;
                flex-wrap: nowrap;
                transition: 0.3s;
            }

            ::slotted(*) {
                flex-shrink: 0;
                user-select: none;
            }
        `
    }
}

window.customElements.define('dz-scroll', DzScroll)